export enum ContractType {
  PROGRESSIVE = 'Progressive Rebate',
  ADJUSTMENT = 'Adjustment Rebate',
  FIXED = 'Fixed Rebate',
  SELLOUT = 'SELLOUT',
}
